import React from 'react';
import ReactDOM from 'react-dom';
import { act } from 'react-dom/test-utils';

// axios インスタンスは import 時に csrf-token の meta を読むため、jsdom では落ちる。リンクの描画には使わない。
jest.mock('../axios', () => ({ get: jest.fn(), post: jest.fn(), put: jest.fn(), patch: jest.fn() }));

// eslint-disable-next-line import/first
import PrPointManagement from './circle/PrPointManagement';
// eslint-disable-next-line import/first
import PrPointSection from './event/PrPointSection';

// TGW-3060: PRポイントの有効期限はダッシュボードのどこにも出ていない。
// 残高の近くから「PRポイントの詳細」（/circles/:id/pr_points。有効期限別の内訳）を開けるようにする。

describe('PRポイントの詳細へのリンク', () => {
  let container;

  beforeEach(() => {
    container = document.createElement('div');
    document.body.appendChild(container);
  });

  afterEach(() => {
    ReactDOM.unmountComponentAtNode(container);
    container.remove();
  });

  const render = (element) => {
    act(() => {
      ReactDOM.render(element, container);
    });
  };

  const detailLink = () => container.querySelector('a[href="/circles/12/pr_points"]');

  it('サークルのダッシュボードの残高から開ける', () => {
    render(<PrPointManagement balance={2400} events={[]} detailUrl="/circles/12/pr_points" />);

    expect(detailLink()).not.toBeNull();
    expect(detailLink().textContent).toContain('有効期限');
  });

  it('イベントのダッシュボードのサークル残高から開ける', () => {
    render(
      <PrPointSection
        status="unset"
        consumed={0}
        remaining={null}
        efficiency={0}
        circle_balance={2400}
        eventId={34}
        detailUrl="/circles/12/pr_points"
      />,
    );

    expect(detailLink()).not.toBeNull();
    expect(detailLink().textContent).toContain('有効期限');
  });
});

// TGW-3060: 残高の右に、期限が一番近いポイント（日時とそのポイント数）を小さく出す
describe('期限が一番近いPRポイント', () => {
  let container;

  beforeEach(() => {
    container = document.createElement('div');
    document.body.appendChild(container);
  });

  afterEach(() => {
    ReactDOM.unmountComponentAtNode(container);
    container.remove();
  });

  const render = (element) => {
    act(() => {
      ReactDOM.render(element, container);
    });
  };

  const nextExpiryText = () => container.querySelector('.o-pr-point__next-expiry')?.textContent;
  const nextExpiry = { expired_on: '2027年4月20日', points: 2400 };

  it('サークルのダッシュボードで、残高の右に出す', () => {
    render(<PrPointManagement balance={2400} events={[]} nextExpiry={nextExpiry} />);

    expect(nextExpiryText()).toBe('直近の期限 2027年4月20日（2,400pt）');
  });

  it('イベントのダッシュボードで、サークル残高の右に出す', () => {
    render(
      <PrPointSection
        status="unset"
        consumed={0}
        remaining={null}
        efficiency={0}
        circle_balance={2400}
        circle_next_expiry={nextExpiry}
        eventId={34}
      />,
    );

    expect(nextExpiryText()).toBe('直近の期限 2027年4月20日（2,400pt）');
  });

  it('ポイントが無いときは出さない', () => {
    render(<PrPointManagement balance={0} events={[]} nextExpiry={null} />);

    expect(nextExpiryText()).toBeUndefined();
  });
});
